export const formatarNumero = (n: number | null | undefined): string =>
  n == null ? "—" : n.toLocaleString("pt-BR");
